export default __webpack_public_path__ + "static/media/photo--sm--game-night.cfa89ea2.jpg";